export type FeedbackType = 'bug' | 'feature' | 'general' | 'other';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5555';

// Submit feedback via server API (triggers Telegram notification)
export const submitFeedback = async (
  type: FeedbackType,
  message: string,
  userId?: string,
  userEmail?: string
): Promise<{ success: boolean; id?: string; error?: string }> => {
  if (!message.trim()) {
    return { success: false, error: 'Message is required' };
  }

  try {
    const response = await fetch(`${API_BASE_URL}/api/feedback`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        type,
        message: message.trim(),
        userId,
        userEmail,
        platform: 'web',
        url: typeof window !== 'undefined' ? window.location.href : undefined,
        userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : undefined,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to submit feedback');
    }

    console.log('[Feedback] Submitted successfully:', data.id);
    return { success: true, id: data.id };
  } catch (error) {
    console.error('[Feedback] Failed to submit:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Failed to submit feedback',
    };
  }
};

// Feedback type labels for UI
export const FEEDBACK_TYPE_LABELS: Record<FeedbackType, string> = {
  bug: 'Bug Report',
  feature: 'Feature Request',
  general: 'General Feedback',
  other: 'Other',
};
